import React, {
    useRef,
    useEffect,
    useState,
    useReducer,
    useContext,
} from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, FormElement } from "@progress/kendo-react-form";
import "./dialog-sign.css";
import CanvasDraw from "@win11react/react-canvas-draw";
import { PDFDocument } from "pdf-lib";
import { Document, Page, pdfjs } from "react-pdf";
import P5ContainerVolume from "./P5ContainerVolume";
import { useMediaQuery } from "@material-ui/core";
import { Context } from "../../../Context";
import { getStampTimeAndTimezone } from "../../../utils";
import { ButtonHLPure } from "..";

const gotToEnd = () => {
    let out = document.getElementsByClassName("k-dialog-content");
    out[0].scrollTop = out[0].scrollHeight * 0.7;
};

const saveImage = (activeStroke = false) => {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let destinationCanvas = document.createElement("canvas");
    destinationCanvas.height = sourceCanvas.height;
    destinationCanvas.width = sourceCanvas.width;
    let destinationContext = destinationCanvas.getContext("2d");
    if (activeStroke) {
        destinationContext.strokeStyle = "#427FBA";
        destinationContext.lineWidth = 5;
        destinationContext.strokeRect(
            0,
            0,
            sourceCanvas.width,
            sourceCanvas.height
        );
    }
    destinationContext.drawImage(sourceCanvas, 0, 0);
    destinationContext.globalCompositeOperation = "destination-over";
    destinationContext.fillStyle = "#4484a500";
    destinationContext.fillRect(
        0,
        0,
        destinationCanvas.width,
        destinationCanvas.height
    );
    let image = destinationCanvas.toDataURL("image/png");
    return {
        newImg: image,
        imageWidth: destinationCanvas.width,
        imageHeight: destinationCanvas.height,
    };
};

function setTextInCanvas(x, y, text) {
    try {
        let sourceCanvas = document.getElementsByTagName("canvas")[1];
        let ctx = sourceCanvas.getContext("2d");
        ctx.font = "bold 25px Arial";
        ctx.textAlign = "center";
        ctx.fillText(text, sourceCanvas.width / 2, y);
    } catch (error) { }
}

function setNamesInCanvas(firstName, lastName) {
    if (firstName.length + lastName.length > 26) {
        setTextInCanvas(0, 205, `${firstName}`)
        setTextInCanvas(0, 235, `${lastName}`)

    } else {
        setTextInCanvas(0, 235, `${firstName} ${lastName}`)
    }
}

const initialValuesState = {
    activeOnSubit: false,
    signatureData: {},
};

function valuesReducerActions(state, action) {
    switch (action.type) {
        case "setActiveOnSubit":
            return { ...state, activeOnSubit: action.data };
        default:
            throw new Error();
    }
}

const DialogAcceptSignatureAutografaCustomVolume = (props) => {
    const { setCanvasData, setShowSignatureCanvas } = useContext(Context);
    let name = props?.currentUserName ?? "";
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [currentSystem, setCurrentSystem] = useState("");
    const { t } = useTranslation();
    const pad = useRef(null);
    const [step, setStep] = useState("sign");
    const [pagesSize, setPagesSize] = useState([]);
    const [imgSignature, setImgSignature] = useState(null);
    const [widthImgSignature, setWidthImgSignature] = useState(400);
    const [heightImgSignature, setHeightImgSignature] = useState(300);
    const [pagesImgs, setPagesImgs] = useState([]);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pager, setPager] = useState(1);
    const [divGreyTextSize, setdivGreyTextSize] = useState(700);
    const greyTextRef = useRef(null);
    const [tempImgPages, setTempImgPages] = useState({});
    const [values, dispatchValues] = useReducer(
        valuesReducerActions,
        initialValuesState
    );
    const [clicAvailable, setClicAvailable] = useState(false);

    let pdfFile =
        "data:application/pdf;filename=file.pdf;base64," + props.signRequestPDF;
    let greyText =
        step === "sign"
            ? "dialogAcceptSignature.noticeCreateSignAutografa"
            : "dialogAcceptSignature.noticeCreateSignAutografaCustomVolume";
    let infodevice = currentSystem.toLowerCase();
    let isMobile = infodevice.includes("android");
    isMobile = isMobile || infodevice.includes("iphone");
    isMobile = isMobile || infodevice.includes("ipad");
    isMobile = isMobile || infodevice.includes("mobile");
    const isTouchScreendevice = () =>
        "ontouchstart" in window || navigator.maxTouchPoints;
    if (isTouchScreendevice()) isMobile = true;
    useEffect(() => {
        const divGreyText = greyTextRef.current;
        if (divGreyText) {
            if (divGreyText.clientWidth) {
                setdivGreyTextSize(divGreyText.clientWidth);
            }
        }
    }, [props.visibleAccept]);

    useEffect(() => {
        let tempArr = [...Array(numPages)];
        for (const key in tempImgPages) {
            tempArr[Number(key)] = tempImgPages[key];
        }
        setPagesImgs(tempArr);
    }, [numPages, tempImgPages]);

    const getPdgPageSize = async () => {
        const pdfDoc = await PDFDocument.load(pdfFile);
        const pages = pdfDoc.getPages()
        let sizes = pages.map((i) => i.getSize());
        setPagesSize(sizes);
    };

    const onDocumentLoadSuccess = (params) => {
        setNumPages(params.numPages);
        setPageNumber(params.numPages);
        setPager(params.numPages);
    };

    const changePage = (offset) => {
        setPageNumber((prevPageNumber) => prevPageNumber + offset);
        setPager((prevPageNumber) => prevPageNumber + offset);
    };

    const previousPage = () => {
        if (pageNumber <= 1) return;
        changePage(-1);
    };

    const nextPage = () => {
        if (pageNumber >= numPages) return;
        changePage(1);
    };

    useEffect(() => {
        setCurrentSystem(navigator.userAgent);
    }, []);

    useEffect(() => {
        if (props.signRequestPDF) getPdgPageSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.signRequestPDF]);

    useEffect(() => {
        if (
            props.visibleAccept &&
            !props.showLoadingRequesting &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) &&
            step === "sign"
        ) {
            setTimeout(() => {
                setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames)
            }, 100);
        }
    }, [
        props.currentSignaturetype.id,
        props.showLoadingRequesting,
        props.tokenUserLastnames,
        props.tokenUserNames,
        props.visibleAccept,
        step,
    ]);
    let pagesNumTemp = [...Array(numPages)];
    const isPhone = useMediaQuery("(max-width:500px)");
    const { innerWidth: fullWidth } = window;
    if (isMobile)
        greyText = "dialogAcceptSignature.noticeCreateSignAutografaMobileVolume";

    return (
        <div>
            {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
                Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? (
                <div className="dialogContent">
                    {/* {props.authorizerCanSign &&
                        props.currentSignaturetype.id ===
                        Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
                            <ButtonHLPure
                                nameBtn={"Autorizar"}
                                primary
                                onClickBtn={() => props.setIsShowAutorizationModal()}
                            />
                        )}
                    {props.userCanSign &&
                        props.currentSignaturetype.id ===
                        Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
                            <ButtonHLPure
                                nameBtn={t("button.sign")}
                                primary
                                onClickBtn={props.toggleDialogAccept}
                            />
                        )} */}
                    {props.visibleAccept &&
                        !props.showLoadingRequesting &&
                        props.currentSignaturetype.id ===
                        Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
                            <Dialog
                                title={t("dialogAcceptSignature.titleAcceptSignRequest", {
                                    signatureType: props.currentSignaturetype.name,
                                })}
                                onClose={props.onDeleteDataAccept}
                                className="dialog-signature"
                            >
                                {/* {step === "location" && (
                    <div
                      className="calligraphic-grey-text"
                      style={{
                        maxWidth: `${divGreyTextSize}px`,
                        height: "auto",
                        backgroundColor: "#DEDEDE",
                        position: "fixed",
                        zIndex: 100,
                      }}
                    >
                      <div style={{ padding: "15px 35px 15px 35px" }}>
                        <p
                          style={{
                            margin: "0px",
                            fontFamily: "Quicksand, sans-serif",
                          }}
                        >
                          {t(greyText)}
                        </p>
                        {greyText ===
                          "dialogAcceptSignature.noticeCreateSignAutografa" && (
                            <p
                              style={{
                                margin: "0px",
                                fontFamily: "Quicksand, sans-serif",
                              }}
                            >
                              {t(
                                "dialogAcceptSignature.noticeCreateSignAutografa2"
                              )}
                            </p>
                          )}
                      </div>
                    </div>
                  )} */}
                                <div
                                    ref={greyTextRef}
                                    style={{
                                        width: "95%",
                                        height: "auto",
                                        margin: "0 0 0 20px",
                                        backgroundColor: "#DEDEDE",
                                        top: 0,
                                        zIndex: 1,
                                    }}
                                >
                                    <div style={{ padding: "15px 20px" }}>
                                        <p
                                            style={{
                                                margin: "0px",
                                                fontFamily: "Quicksand, sans-serif",
                                                paddingBottom: "10px",
                                            }}
                                        >
                                            {t(greyText)}
                                        </p>{" "}
                                        {greyText ===
                                            "dialogAcceptSignature.noticeCreateSignAutografa" && (
                                                <p
                                                    style={{
                                                        margin: "0px",
                                                        fontFamily: "Quicksand, sans-serif",
                                                    }}
                                                >
                                                    {t("dialogAcceptSignature.noticeCreateSignAutografa2")}
                                                </p>
                                            )}
                                    </div>
                                </div>
                                <div>
                                    <Form
                                        style={{ margin: "0px" }}
                                        onSubmit={props.onSubmit}
                                        allowSubmit={true}
                                        className="formCustomSignature"
                                        valid={true}
                                        touched={true}
                                        visited={true}
                                        render={(formRenderProps) => {
                                            let disabled = false;
                                            return (
                                                <FormElement
                                                    style={{
                                                        maxWidth: "450px !important",
                                                        width: "100%",
                                                        margin: "auto",
                                                    }}
                                                >
                                                    <div>
                                                        {step === "sign" && (
                                                            <>
                                                                {/* <div
                                    className={`button-dialog-accept button-dialog-accept-size`}
                                  >
                                    <span
                                      className="one-more-signature"
                                      onClick={() => {
                                        props.setImgSignature(null);
                                        pad.current.clear();
                                        setTimeout(() => {
                                          setTextInCanvas(
                                            100,
                                            235,
                                            `${props.tokenUserNames} ${props.tokenUserLastnames}`
                                          );
                                        }, 0);
                                        setTimeout(
                                          () =>
                                            props.setImgSignature(saveImage()),
                                          10
                                        );
                                      }}
                                    >
                                      {t("dialogAcceptSignature.clean")}
                                    </span>
                                  </div> */}
                                                                <div className={"canvas-draw"}>
                                                                    <CanvasDraw
                                                                        ref={pad}
                                                                        loadTimeOffset={0}
                                                                        lazyRadius={2}
                                                                        brushRadius={2}
                                                                        brushColor={"#000"}
                                                                        catenaryColor={"#0a0302"}
                                                                        gridColor={"rgba(150,150,150,0.17)"}
                                                                        hideGrid={true}
                                                                        canvasWidth={"95%"}
                                                                        canvasHeight={300}
                                                                        disabled={false}
                                                                        immediateLoading={true}
                                                                        hideInterface={false}
                                                                        onChange={(e) => {
                                                                            setClicAvailable(true)
                                                                        }
                                                                        }
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                        {step === "location" && (
                                                            <div
                                                                style={{
                                                                    width: pagesSize[0].width + 16,
                                                                    height: pagesSize[0].height + 16,
                                                                }}
                                                            >
                                                                <div
                                                                    className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                                                                >
                                                                    <span
                                                                        class="k-icon k-i-arrow-double-60-left icon-bar"
                                                                        onClick={() => {
                                                                            setPageNumber(1);
                                                                            setPager(1);
                                                                        }}
                                                                    ></span>
                                                                    <span
                                                                        class="k-icon k-i-arrow-60-left icon-bar"
                                                                        onClick={previousPage}
                                                                    ></span>
                                                                    <div
                                                                        className="pagec"
                                                                        style={{
                                                                            color: "#427FBA",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                            padding: '0px 5px'
                                                                        }}
                                                                    >
                                                                        Página
                                                                        <input
                                                                            style={{
                                                                                width: "32px",
                                                                                marginLeft: "4px",
                                                                                marginRight: "3px",
                                                                            }}
                                                                            type="text"
                                                                            value={pager}
                                                                            onChange={({ target }) => {
                                                                                setPager(Number(target.value));
                                                                                if (Number(target.value) <= numPages) {
                                                                                    if (Number(target.value) <= 0) {
                                                                                        setPageNumber(1);
                                                                                        setPager(1);
                                                                                    } else
                                                                                        setPageNumber(Number(target.value));
                                                                                } else
                                                                                    setTimeout(() => {
                                                                                        setPager(pageNumber);
                                                                                    }, 1000);
                                                                            }}
                                                                        />
                                                                        de {numPages || "--"}
                                                                    </div>
                                                                    <span
                                                                        class="k-icon k-i-arrow-60-right icon-bar"
                                                                        onClick={nextPage}
                                                                    ></span>
                                                                    <span
                                                                        class="k-icon k-i-arrow-double-60-right icon-bar"
                                                                        onClick={() => {
                                                                            setPageNumber(numPages);
                                                                            setPager(numPages);
                                                                        }}
                                                                    ></span>
                                                                </div>
                                                                {pagesImgs.map((item, index) => (
                                                                    <React.Fragment key={String(index)}>
                                                                        <div
                                                                            style={
                                                                                index === pageNumber - 1
                                                                                    ? {}
                                                                                    : { display: "none" }
                                                                            }
                                                                        >
                                                                            <P5ContainerVolume
                                                                                tFunction={t}
                                                                                base64Img={item}
                                                                                widthImg={pagesSize[index].width}
                                                                                heightImg={pagesSize[index].height}
                                                                                imgSignature={imgSignature}
                                                                                // widthImgSignature={(widthImgSignature / 2) * 0.8}
                                                                                // heightImgSignature={(heightImgSignature / 2) * 0.8}
                                                                                widthImgSignature={widthImgSignature}
                                                                                heightImgSignature={heightImgSignature}
                                                                                pageNumber={index}
                                                                                save={async (params) => {
                                                                                    let page = index + 1
                                                                                    const stampTime = await getStampTimeAndTimezone()
                                                                                    props.assignStampVolume(stampTime)
                                                                                    if (stampTime === false) {
                                                                                        props.onErrorTimeStamp()
                                                                                        return false
                                                                                    }

                                                                                    let signatures = [params]
                                                                                    let fileSignImage = null;
                                                                                    await fetch(imgSignature)
                                                                                      .then((res) => res.blob())
                                                                                      .then((blob) => {
                                                                                        const file = new File(
                                                                                          [blob],
                                                                                          "signature.png"
                                                                                        );
                                                                                        fileSignImage = file;
                                                                                      });
                                                                                    let allSignatures = signatures.map((signature, indx) => {
                                                                                        const heightImg = pagesSize[0].height
                                                                                        const hRect = heightImgSignature / 3
                                                                                        return {
                                                                                          ...signature,
                                                                                          x: signature.x,
                                                                                          y: signature.y,
                                                                                          width: signature.width,
                                                                                          height: signature.height,
                                                                                          page: page,
                                                                                          index: indx + 1,
                                                                                          heightImg: heightImg,
                                                                                          fileSignImage,
                                                                                          isMobile,
                                                                                          imgSignature: imgSignature,
                                                                                          fileName: `sign${indx + 1}`
                                                                                        }
                                                                                    });

                                                                                    props.setAllSignatures(allSignatures);
                                                                                    props.onSubmit("", "", stampTime);
                                                                                }}
                                                                                activeOnSubit={values.activeOnSubit}
                                                                                signatureData={values.signatureData}
                                                                                dispatchValues={dispatchValues}
                                                                                back={() => {
                                                                                    setStep("sign")
                                                                                    setClicAvailable(false)
                                                                                }}
                                                                                cancel={() => {
                                                                                    setStep("sign");
                                                                                    props.onDeleteDataAccept();
                                                                                    setClicAvailable(false)
                                                                                }}
                                                                                isMobile={false}
                                                                                gotToEnd={gotToEnd}
                                                                                isPhone={isPhone}
                                                                            />
                                                                        </div>
                                                                    </React.Fragment>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {step === "sign" && (
                                                            <div
                                                                className={`button-dialog-accept button-dialog-accept-size ${step === "location" &&
                                                                    "button-on-custom-signature"
                                                                    }`}
                                                            >
                                                                <div
                                                                    item
                                                                    xs={12}
                                                                    lg={12}
                                                                    md={12}
                                                                    sm={12}
                                                                    es={12}
                                                                    className={`button-dialog-accept button-dialog-accept-size`}
                                                                >
                                                                    <ButtonHLPure
                                                                        nameBtn={"Cerrar"}
                                                                        onClickBtn={props.onDeleteDataAccept}
                                                                    />

                                                                    {/* Btn clean */}
                                                                    <ButtonHLPure
                                                                        nameBtn={t("dialogAcceptSignature.clean")}
                                                                        onClickBtn={() => {
                                                                            setClicAvailable(false)
                                                                            props.setImgSignature(null);
                                                                            pad.current.clear();
                                                                            setTimeout(() => {
                                                                                setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames)
                                                                            }, 0);
                                                                            setTimeout(
                                                                                () =>
                                                                                    props.setImgSignature(saveImage()),
                                                                                10
                                                                            );
                                                                        }}
                                                                    />
                                                                    <ButtonHLPure
                                                                        disabled={!clicAvailable}
                                                                        nameBtn={t("dialogAcceptSignature.captureSignature")}
                                                                        primary
                                                                        onClickBtn={async () => {
                                                                            const stampTime = await getStampTimeAndTimezone()
                                                                            props.assignStampVolume(stampTime)
                                                                            if (stampTime === false) {
                                                                                props.onErrorTimeStamp()
                                                                                return false
                                                                            }
                                                                            setTextInCanvas(
                                                                                100,
                                                                                265,
                                                                                `${stampTime}`
                                                                            );
                                                                            setTimeout(() => {
                                                                                let {
                                                                                    newImg,
                                                                                    imageWidth,
                                                                                    imageHeight,
                                                                                } = saveImage();
                                                                                setImgSignature(newImg);
                                                                                if (isMobile) {
                                                                                    let imgSignatureStroke =
                                                                                        saveImage(true);
                                                                                    setCanvasData({
                                                                                        imgSignature:
                                                                                            imgSignatureStroke.newImg,
                                                                                        pagesImgs,
                                                                                        numPages,
                                                                                        pagesSize,
                                                                                        pager,
                                                                                        pageNumber,
                                                                                        greyText: t(
                                                                                            "dialogAcceptSignature.noticeCreateSignAutografaCustomMobile"
                                                                                        ),
                                                                                        widthImgSignature,
                                                                                        heightImgSignature,
                                                                                        page: pageNumber,
                                                                                        back: () => {
                                                                                            props.onDeleteDataAccept();
                                                                                            setTimeout(() => {
                                                                                                props.toggleDialogAccept();
                                                                                            }, 100);
                                                                                        },
                                                                                        save: (params) => {
                                                                                            let signatureImgeData = {
                                                                                                ...params,
                                                                                            };
                                                                                            setStep("sign");
                                                                                            props.setSignatureImgeData(
                                                                                                signatureImgeData
                                                                                            );
                                                                                            setShowSignatureCanvas(false);
                                                                                        },
                                                                                    });
                                                                                }
                                                                                props.setImgSignature({
                                                                                    imgSignature: newImg,
                                                                                    imageWidth,
                                                                                    imageHeight,
                                                                                });
                                                                                setWidthImgSignature(imageWidth);
                                                                                setHeightImgSignature(imageHeight);
                                                                                if (isMobile) {
                                                                                    setShowSignatureCanvas(true);
                                                                                } else setStep("location");
                                                                            }, 0);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </FormElement>
                                            );
                                        }}
                                    />
                                </div>
                            </Dialog>
                        )}
                </div>
            ) : null}
            <div style={{ display: "none" }}>
                <Document
                    file={props.result ?? pdfFile}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={e => console.log({ e })}>
                    <React.Fragment>
                        {pagesNumTemp.map((item, index) => (
                            <React.Fragment>
                                <Page
                                    className={`import-pdf-page-${index + 1}`}
                                    pageNumber={index + 1}
                                    onRenderSuccess={() => {
                                        const importPDFCanvas = document.querySelector(
                                            `.import-pdf-page-${index + 1} canvas`
                                        );
                                        const pdfAsImageSrc = importPDFCanvas.toDataURL();
                                        if (!tempImgPages[index]) {
                                            setTempImgPages({
                                                ...tempImgPages,
                                                [index]: pdfAsImageSrc,
                                            });
                                        }
                                        setTimeout(() => {
                                            props.toggleLoadingRequesting(false)
                                        }, 2000)
                                    }}
                                />
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                </Document>
            </div>
        </div>
    );
};

export { DialogAcceptSignatureAutografaCustomVolume as default };
